class Brevet {
	id = null;
	date = null;
	candidate_id = null;
	course_id = null;
	price = null;
	brevet_number = '';
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Brevet;
